<template>

  <partner-dept-moves :partner-id="branchDetails.Partner_ID"
                      :partner-name="branchDetails.PartnerBrandName"></partner-dept-moves>
</template>

<script>
import PartnerDeptMoves from "@/views/Financial/components/PartnerDeptMoves";
import {mapGetters} from "vuex";

export default {
  name: "PartnerMoves",
  components: {PartnerDeptMoves},
  computed: {
    ...mapGetters([
      "partner"
    ]),
    ...mapGetters('branch',
        [
          "branchDetails"
        ])
  }
}
</script>

<style scoped>

</style>
